
            console.log("Mode: " + import.meta.env.MODE)
            if (process.env.NODE_ENV === "production") {
                (function () {
                    var webSdkScript = document.createElement("script");
                    webSdkScript.crossOrigin = "anonymous";
                    webSdkScript.src =
                        "https://unpkg.com/@grafana/faro-web-sdk@^1.4.0/dist/bundle/faro-web-sdk.iife.js";

                    webSdkScript.onload = () => {
                        window.GrafanaFaroWebSdk.initializeFaro({
                            url: "https://faro-collector-prod-eu-west-2.grafana.net/collect/ca5c2aea1d9ce93d84f95ae08c917729",
                            app: {
                                name: "Zebra Frontend - zndznd",
                                version: "1.0.0",
                                environment: "production",
                            },
                        });

                        var webTracingScript = document.createElement("script");
                        webTracingScript.crossOrigin = "anonymous";
                        webTracingScript.src =
                            "https://unpkg.com/@grafana/faro-web-tracing@^1.4.0/dist/bundle/faro-web-tracing.iife.js";

                        webTracingScript.onload = () => {
                            window.GrafanaFaroWebSdk.faro.instrumentations.add(
                                new window.GrafanaFaroWebTracing.TracingInstrumentation()
                            );
                        };

                        document.head.appendChild(webTracingScript);
                    };

                    document.head.appendChild(webSdkScript);
                })();
            }
        